// extracted by mini-css-extract-plugin
export default {"sidebarWrapper":"SideBar_sidebarWrapper__HoD-8","logo":"SideBar_logo__CFVoN"};